import EditIcon from "@mui/icons-material/Edit";
import {
  Button,
  Dialog,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  name: string;
  onChange: (name: string) => void;
};

export const EditFboName: React.FC<Props> = ({ name, onChange }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [newName, setNewName] = useState<string>(name);

  return (
    <>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography width={150}>{name}</Typography>
        <IconButton onClick={() => setOpen(true)}>
          <EditIcon />
        </IconButton>
      </Stack>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <Typography variant="h6" sx={{ p: 2 }}>
          {t("screens.editFboName.title")}
        </Typography>
        <Stack direction="column" spacing={2} sx={{ p: 2 }}>
          <TextField
            label={t("screens.editFboName.nameLabel")}
            value={newName}
            onChange={(evt) => setNewName(evt.target.value)}
          />
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button onClick={() => setOpen(false)}>{t("screens.editFboName.cancelButton")}</Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                setOpen(false);
                onChange(newName);
              }}
            >
              {t("screens.editFboName.saveButton")}
            </Button>
          </Stack>
        </Stack>
      </Dialog>
    </>
  );
};
